
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.758.336v.383c-.25.036-.43.104-.54.203a.52.52 0 00-.163.406c0 .146.05.328.148.547.1.219.24.48.422.781l1.133 1.899L5.875 2.75c.167-.27.292-.487.375-.648.083-.162.14-.297.172-.407.036-.11.055-.221.055-.336a.602.602 0 00-.141-.406C6.242.84 6.086.76 5.867.72V.336h2.899v.383a1.73 1.73 0 00-.524.273c-.15.12-.315.294-.492.524-.172.229-.42.59-.742 1.086L5.242 5.336l1.985 3.266c.28.463.481.789.601.976.125.182.24.339.344.469.11.125.224.234.344.328.125.094.278.175.46.242V11h-3.43v-.383c.24-.042.418-.107.532-.195.115-.094.172-.232.172-.414 0-.146-.04-.307-.117-.485a5.142 5.142 0 00-.344-.656l-1.414-2.36-1.492 2.446c-.25.412-.375.75-.375 1.016 0 .172.047.312.14.422.094.109.25.184.47.226V11H.163v-.383c.193-.057.352-.125.477-.203.125-.083.244-.187.359-.312.115-.125.242-.284.383-.477.14-.193.364-.529.672-1.008l1.843-2.875-2.203-3.625a14.146 14.146 0 00-.476-.726 2.65 2.65 0 00-.297-.368A.922.922 0 00.68.828a1.388 1.388 0 00-.25-.11V.337h3.328z","fill":"currentColor"}})])
          )
        }
      }
    